import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["video", "overlay", "playBtn", "playIcon", "pauseIcon", "sound", "soundOnIcon", "soundOffIcon"];

  connect() {
    this.adShown = false;

    this.startPlayback();

    this.videoTarget.addEventListener("playing", () => this.syncUI());
    this.videoTarget.addEventListener("pause", () => this.syncUI());
    this.videoTarget.addEventListener("volumechange", () => this.syncUI());

    this.syncUI();
  }

  startPlayback() {
    this.videoTarget.play().catch(() => {
      this.videoTarget.muted = true;
      this.videoTarget.play().catch(() => this.showOverlay());
    });
  }

  requestRewardOnce() {
    if (this.adShown || !window.api?.requestReward) return false;
    this.adShown = true;
    window.api.requestReward(
      "reward",
      () => {},
      () => this.videoTarget.play(),
      () => this.videoTarget.pause(),
    );
    return true;
  }

  play() {
    if (this.requestRewardOnce()) return;
    this.videoTarget.muted = false;
    this.videoTarget.play();
  }

  togglePlay() {
    if (this.requestRewardOnce()) return;
    this.videoTarget.paused ? this.play() : this.videoTarget.pause();
  }

  toggleMute() {
    if (this.requestRewardOnce()) return;
    this.videoTarget.muted = !this.videoTarget.muted;
  }

  syncUI() {
    const paused = this.videoTarget.paused;
    const muted = this.videoTarget.muted;

    // Big overlay play button — show only when paused
    if (paused) {
      this.overlayTarget.classList.remove("hidden");
    } else {
      this.overlayTarget.classList.add("hidden");
    }

    // Bottom-left play/pause icon toggle
    if (paused) {
      this.playIconTarget.classList.remove("hidden");
      this.pauseIconTarget.classList.add("hidden");
    } else {
      this.playIconTarget.classList.add("hidden");
      this.pauseIconTarget.classList.remove("hidden");
    }

    // Bottom-right sound button
    if (!paused) {
      this.soundTarget.classList.remove("hidden");
      if (muted) {
        this.soundOnIconTarget.classList.remove("hidden");
        this.soundOffIconTarget.classList.add("hidden");
      } else {
        this.soundOnIconTarget.classList.add("hidden");
        this.soundOffIconTarget.classList.remove("hidden");
      }
    } else {
      this.soundTarget.classList.add("hidden");
    }
  }

  showOverlay() {
    this.overlayTarget.classList.remove("hidden");
  }
}
